import { render } from "./Header.vue?vue&type=template&id=4bfc4c4b&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=4bfc4c4b&lang=stylus&scoped=true"
import "./Header.vue?vue&type=style&index=1&lang=stylus"
script.render = render
script.__scopeId = "data-v-4bfc4c4b"

export default script